// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__WXDD6","input":"style_input__B9ihn","icon":"style_icon__tk7ac"};